'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var subscription = exports.subscription = {
  title: 'Suscripción',
  description: 'Accede a miles de cursos y Carreras de cualquier temática. Con Tutores que te ayudarán a crear el itinerario formativo perfecto',
  background_url: 'https://dev-res.thumbr.io/images/suscriptions-banner.jpg',
  main_cta: 'Conoce los planes',
  reasons_title: 'Ventajas de la suscripción',
  reasons: JSON.stringify(['careers', 'tutors', 'unlimited']),
  careers_icon: 'https://lib.tutellus.com/images/icons/routes.svg',
  careers_title: 'Carreras formativas',
  careers_description: 'Apúntate a las Carreras que quieras y transforma tu vida subiéndola de nivel',
  tutors_icon: 'https://lib.tutellus.com/images/icons/lifesaver.svg',
  tutors_title: 'Tutores personales',
  tutors_description: 'Dispondrás de un Tutor que te ayudará siempre que lo necesites',
  unlimited_icon: 'https://lib.tutellus.com/images/icons/infinite.svg',
  unlimited_title: 'Consumo ilimitado',
  unlimited_description: 'Accederás a cualquier curso, de cualquier temática y nivel, siempre',
  choose_offer_title: 'Selecciona un plan para tu Carrera',
  choose_offer_description: 'Contrata el plan que mejor se adapte a ti. Podrás pararlo o cancelarlo cuando quieras',
  choose_offer_legal: 'Cualquier plan se puede contratar por tarjeta de crédito/débito y PayPal, en distintas monedas locales (EU, USD, MXN, COL, CLP, PEN); desde Europa se incluye la Domiciliación bancaria, y desde España se añade el pago a plazos. Cualquier plan se renueva automáticamente cada período hasta que quieras cancelarlo, en cuyo caso basta con que nos lo comuniques por teléfono, mail, chat, notificación o código morse.',
  find_a_career: 'Encuentra tu Carrera ideal',
  corporate_title: '¿Eres una empresa?',
  secondary_cta: 'Accede a los planes para Empresas',
  monthly_catch: '',
  quarterly_catch: 'Contratando 1 trimestre',
  yearly_catch: 'Contratando 1 año',
  monthly: 'Mensual',
  quarterly: 'Trimestral',
  yearly: 'Anual',
  yearly_claim: 'Recomendado',
  monthly_claim: '',
  quarterly_claim: '',
  full_access: 'Accedes a todas las Carreras Cursos',
  unlimited_access: 'Acceso ilimitado a todos los cursos desde web y app',
  teacher_support: 'Soporte del Profesor y de Tutores específicos',
  all_certificates: 'Certificados en todos los cursos (gratis y de pago)',
  payment_frequency: 'Frecuencia de pago',
  monthly_frequency: 'Cada mes',
  quarterly_frequency: 'Cada 3 meses',
  yearly_frequency: 'Cada año',
  purchase: 'Contratar',
  period: 'mes'
};


//////////////////
// WEBPACK FOOTER
// ../i18n/lib/es/subscription.js
// module id = 703
// module chunks = 0